<template>
  <svg width="17" height="21" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 1C12.642 1 16 4.48 16 8.773 16 14.818 8.5 20 8.5 20S1 14.818 1 8.773C1 4.48 4.358 1 8.5 1zm0 5.182c-1.38 0-2.5 1.16-2.5 2.59 0 1.432 1.12 2.592 2.5 2.592s2.5-1.16 2.5-2.591c0-1.431-1.12-2.591-2.5-2.591z"
      :stroke="stroke"
      stroke-width="2"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'LocationPinSVG',
  props: {
    stroke: {
      type: String,
      default: '#590F85'
    }
  }
}
</script>
